import { useEffect, useRef } from "react";

export const usePolling = (callback, intervalMs = 10000) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const id = window.setInterval(() => {
      callbackRef.current();
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
};
